module.exports = __webpack_public_path__ + "favicons/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/favicons/favicon.ico
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--2-0!/tool/node_modules/img-loader/index.js!/tool/project/client/src/site__mhf/favicons/favicon.ico
// module chunks = site__mhf